var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":"Salvar este dispositivo","hide-details":""},model:{value:(_vm.saveDevice),callback:function ($$v) {_vm.saveDevice=$$v},expression:"saveDevice"}})
}
var staticRenderFns = []

export { render, staticRenderFns }